require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-labs-ii-integration.json") })
        }
      }, "path---works-labs-ii-integration");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-labs-ii-integration!./.cache/json/works-labs-ii-integration.json
// module id = 380
// module chunks = 231608221292675